import { render, staticRenderFns } from "./CustomerList.component.pug?vue&type=template&id=cf34d9d6&scoped=true&lang=pug&"
import script from "./CustomerList.component.ts?vue&type=script&lang=ts&"
export * from "./CustomerList.component.ts?vue&type=script&lang=ts&"
import style0 from "./CustomerList.component.scss?vue&type=style&index=0&id=cf34d9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf34d9d6",
  null
  
)

export default component.exports